import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography, useTheme, useMediaQuery, Theme } from '@material-ui/core';

import { Page } from 'components';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: 0,
    paddingTop: '10vh',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center'
  },
  imageContainer: {
    position: 'relative',
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  },
  content: {
    position: 'absolute',
    top: '50%',
    left: '40%',
    transform: 'translate(-50%, -50%)',
    fontSize: '5vw',
    color: 'rgb(238, 238, 238)',
    fontWeight: 600
  },
  image: {
    width: '100%',
    height: 'auto'
  },
  buttonContainer: {
    marginTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center'
  }
}));

const Error401 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page
      className={classes.root}
      title="Logged Out"
    >
      <Typography
        align="center"
        variant={mobileDevice ? 'h4' : 'h1'}
      >
        You have been successfully logged out.
      </Typography>
      <Typography
        align="center"
        variant="subtitle2"
      >
        You may now close this tab.
      </Typography>
      <div className={classes.imageContainer}>
        <img
          alt="Under development"
          className={classes.image}
          src="/images/undraw_authentication_fsn5.png"
        />
        <Typography
          align="center"
          className={classes.content}
          variant="h1"
        >
          Logged Out
        </Typography>
      </div>
    </Page>
  );
};

export default Error401;
